const navMainToggleCheck = ( _storeDevice ) =>
{
	return ( window.innerWidth <= parseInt( _storeDevice.deviceViewportSizes['xxl'].replace('px', '') ) ) ? 'mobile' : 'desktop';
}

const navMainToggleInit = ( _navMainToggle, _navMain, _storeDevice ) => 
{
	// Handle size responsive observe
	_storeDevice.deviceResizeDebounceCallbacks.push([( _event ) => 
	{
		document.querySelector( 'html' ).setAttribute( `data-nav-main`, navMainToggleCheck( _storeDevice ) );

	}, null]);

	// Handle size init
	document.querySelector( 'html' ).setAttribute( `data-nav-main`, navMainToggleCheck( _storeDevice ) );
	document.querySelector( 'html' ).setAttribute( `data-nav-main-expanded`, _navMainToggle.classList.contains( 'active' ) );

	_navMainToggle.addEventListener( `click`, ( _event ) => {

		const navMainToggleState = _navMainToggle.classList.toggle('active');
		document.querySelector( 'html' ).setAttribute( `data-nav-main-expanded`, navMainToggleState );
		window.scrollTo(0, 0);

	});
}

const mainNavSubMenuReset = ( _navMain, _navMainSubMenu, _storeDevice ) =>
{

	// Handle size responsive observe
	_storeDevice.deviceResizeDebounceCallbacks.push([( _event ) => 
	{
		_navMainSubMenu.forEach( ( _entry, _index) => 
		{
			//console.log( _entry )
			// let parentNode = ( _event.currentTarget.parentNode.parentNode.nodeName === 'A' ) ? _event.currentTarget.parentNode.parentNode.parentNode : _event.currentTarget.parentNode.parentNode;
			// parentNode.classList.remove('active');
		});

	}, null]);

}

const navMainSubMenuToggleInit = ( _navMainToggle, _navMain, _storeDevice ) => 
{

	const navMainSubMenu = _navMain.querySelectorAll( 'li:has( > button )' );
	
	mainNavSubMenuReset( _navMain, navMainSubMenu, _storeDevice );


	navMainSubMenu.forEach( ( _entry, _index) => 
	{
		_entry.addEventListener( 'click', ( _event ) => 
		{

			//_event.preventDefault();
			//_event.stopPropagation();

			let parentNode = _event.currentTarget;//( _event.currentTarget.parentNode.parentNode.nodeName === 'A' ) ? _event.currentTarget.parentNode.parentNode.parentNode : _event.currentTarget.parentNode.parentNode;

			navMainSubMenu.forEach( ( __entry, ___index) =>
			{
				let parentNodeEntry = __entry;//( __entry.parentNode.parentNode.nodeName === 'A' ) ? __entry.parentNode.parentNode.parentNode : __entry.parentNode.parentNode;
				console.log( parentNodeEntry )
				if ( parentNode !== parentNodeEntry ) parentNodeEntry.classList.remove('active');
			});

			parentNode.classList.toggle( 'active' );

			//return false;
		});
	});

}

export {
	navMainToggleInit,
	navMainSubMenuToggleInit
}